import i18n from 'i18next'
import moment from 'moment'
import 'moment/locale/pl'
import { initReactI18next } from 'react-i18next'

import { themes } from '@/themes/clients'
import { getClientType, getLanguageOverride } from '@/services/clientConfig'

import en from './locales/en.json'
import pl from './locales/pl.json'

// Importing a moment locale switches the global locale - restore the default
moment.locale('en')

const resources = {
  en, pl
}

i18n.on('languageChanged', lng => {
  moment.locale(lng)
  document.documentElement.lang = lng
})

const initialLanguage = getLanguageOverride() || themes[getClientType()]?.language || 'en'

i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage,
  debug: true,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false
  }
})

moment.locale(i18n.language)
document.documentElement.lang = i18n.language

export default i18n
